namespace $.$$ {

	export class $shm_hitalama_map_widget_float_opencode_session extends $.$shm_hitalama_map_widget_float_opencode_session {

	}

}
